// 订单设置
<template>
  <div class="tape-tabel">
    <qz-card title="通话录音" extra="仅针对已授权并在订单保护有效期内进行拨打的人员。" divider>
      <el-row>
        <el-table :data="tableData" border v-loading="loading" style="width: 100%">
          <el-table-column prop="account_name" label="名称"></el-table-column>
          <el-table-column prop="tel_b" label="装企手机号"></el-table-column>
          <el-table-column prop="account_type_name" label="登录账号类型"> </el-table-column>
          <el-table-column prop="tel_x" label="虚拟号"> </el-table-column>
          <el-table-column prop="call_num" label="拨号次数"> </el-table-column>
          <el-table-column prop="call_on_num" label="拨通次数"> </el-table-column>
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <el-button @click="handlePop(scope.row)" type="text">录音记录</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-dialog title="录音记录" width="66%" :visible.sync="dialogTableVisible">
        <el-table border :data="gridData">
          <el-table-column property="created_date" label="产生时间" width="200"></el-table-column>
          <el-table-column property="tel_main" label="主叫号码" width="150"></el-table-column>
          <el-table-column property="tel_called" label="被叫号码" width="150"></el-table-column>
          <el-table-column property="starttime" label="接听时间" width="200"></el-table-column>
          <el-table-column property="releasetime" label="挂断时间" width="200"></el-table-column>
          <!-- <el-table-column property="call_action_name" label="呼叫动作" width="100"></el-table-column> -->
          <el-table-column label="通话录音">
            <template slot-scope="scope">
              <audio controls="controls">
                <source :src="scope.row.record_url" />
              </audio>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </qz-card>
  </div>
</template>

<script>
import apiTape from '@/api/tape';

export default {
  name: 'tapeTabel',
  components: {
    QzCard: () => import('@/components/card.vue'),
  },
  data() {
    return {
      orderId: '',
      tableData: [],
      dialogTableVisible: false,
      gridData: [],
      loading: false,
    };
  },
  created() {
    this.orderId = this.$route.query.id;
    this.getList(this.orderId);
  },
  methods: {
    getList(e) {
      this.loading = true;
      apiTape
        .orderLog({
          order_id: e,
        })
        .then((res) => {
          if (parseInt(res.data.error_code, 10) === 0) {
            if (res.data.data.list.length <= 0 && this.currentPage > 1) {
              // eslint-disable-next-line no-plusplus
              this.currentPage--;
              this.getList();
            } else {
              this.loading = false;
              this.tableData = [];
              res.data.data.list.forEach((item) => {
                this.tableData.push(item);
              });
            }
          } else {
            this.loading = false;
            this.$message({
              type: 'error',
              message: res.data.error_msg,
              center: true,
              offset: 200,
            });
          }
        });
    },
    handlePop(e) {
      this.dialogTableVisible = true;
      this.gridData = [];
      apiTape
        .orderVolice({
          order_id: e.order_id,
          sub_id: e.sub_id,
        })
        .then((res) => {
          if (parseInt(res.data.error_code, 10) === 0) {
            this.gridData = res.data.data.list;
          } else {
            this.$message({
              type: 'error',
              message: res.data.error_msg,
              center: true,
              offset: 200,
            });
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.tape-tabel {
  overflow: hidden;
}
</style>
